import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { trackWhatsAppClick } from '../analytics';

export const WaIcon = ({ className = 'ico-wa' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm0 18.2c-1.6 0-3.1-.4-4.4-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2Zm4.6-6.1c-.3-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1-.2.3-.6.8-.8 1-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.4-3c-.3-.4 0-.5.1-.7l.4-.5c.1-.2.1-.3.2-.5s0-.4 0-.5l-.8-1.9c-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.3-.2.3-.9.9-.9 2.2s.9 2.5 1 2.7c.1.2 1.8 2.8 4.4 3.9.6.3 1.1.4 1.5.6.6.2 1.2.2 1.6.1.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2 0-.1-.2-.2-.4-.3Z" />
  </svg>
);

export const LogoIcon = () => (
  <svg viewBox="0 0 32 32" fill="none" aria-hidden="true">
    <path d="M2 16s6-8 15-8c7 0 12 5 13 8-1 3-6 8-13 8C8 24 2 16 2 16Z" fill="#0D4A57" />
    <circle cx="23" cy="14.5" r="1.8" fill="#fff" />
    <path d="M2 16l6-5v10l-6-5Z" fill="#E4572E" />
  </svg>
);

const LINKS = [
  { href: '/#pedido', label: 'Haz tu pedido' },
  { href: '/#nutricion', label: 'Nutrición' },
  { href: '/#cachama', label: 'La cachama' },
  { href: '/#recetas', label: 'Recetas' },
  { href: '/#proceso', label: 'Nuestro proceso' },
  { href: '/#cobertura', label: 'Cobertura' },
  { href: '/#faq', label: 'Preguntas' },
  { href: '/#juego', label: 'Juegos' },
];

const Header = () => {
  const [abierto, setAbierto] = useState(false);

  return (
    <header className="site-header">
      <div className="wrap nav">
        <a className="logo" href="/#inicio"><LogoIcon /> Finca Pescado</a>
        <nav className="nav-links" aria-label="Navegación principal">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} className={l.label === 'Juegos' ? 'nav-juegos' : undefined} data-testid={l.label === 'Juegos' ? 'nav-juegos' : undefined}>{l.label}</a>
          ))}
          <a
            className="btn btn-wa"
            href="https://wa.me/573106846758?text=Hola%20Finca%20Pescado%2C%20quiero%20informaci%C3%B3n%20sobre%20la%20cachama%20fresca"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackWhatsAppClick('header')}
          >
            <WaIcon /> WhatsApp
          </a>
          <button
            className="nav-burger"
            aria-label={abierto ? 'Cerrar menú' : 'Abrir menú'}
            aria-expanded={abierto}
            aria-controls="menu-movil"
            onClick={() => setAbierto((a) => !a)}
            data-testid="nav-burger"
          >
            {abierto ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>
      </div>
      {abierto && (
        <nav className="nav-movil" id="menu-movil" aria-label="Menú móvil">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setAbierto(false)}>{l.label}</a>
          ))}
          <a
            href="https://wa.me/573106846758?text=Hola%20Finca%20Pescado%2C%20quiero%20informaci%C3%B3n%20sobre%20la%20cachama%20fresca"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-movil-wa"
            onClick={() => { trackWhatsAppClick('header'); setAbierto(false); }}
          >
            WhatsApp: 310 684 6758
          </a>
        </nav>
      )}
    </header>
  );
};

export default Header;